interface UseDatasetSummaryProps {
  validationEncounterCount: number;
  testEncounterCount: number;
  trainingEncounterCount: number;
}

interface UseDatasetSummaryResults {
  validationPercent: number;
  trainingPercent: number;
  testPercent: number;
  total: number;
}
export const useDatasetSummary = ({
  validationEncounterCount,
  testEncounterCount,
  trainingEncounterCount,
}: UseDatasetSummaryProps): UseDatasetSummaryResults => {
  const total = validationEncounterCount + testEncounterCount + trainingEncounterCount;

  const validationPercent = total ? (validationEncounterCount / total) * 100 : 0;

  const trainingPercent = total ? (trainingEncounterCount / total) * 100 : 0;

  const testPercent = total ? (testEncounterCount / total) * 100 : 0;
  return {
    validationPercent,
    trainingPercent,
    testPercent,
    total,
  };
};
